// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import DesShareLibrarySearchBox from 'viewmodel/DesShareLibrarySearchBoxViewModel';
import DesShareLibrarySearchResultsForTeams from 'viewmodel/DesShareLibrarySearchResultsForTeamsViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "selectedTeams": null
    },
    "lifecycleHooks": {
        "onMount": {
            "action": "setCustomAttribute"
        },
        "onUpdate": {
            "observers": [
                "props.accsessionid",
                "props.libraryid",
                "props.emailtemplateid",
                "props.emailtemplateparams",
                "props.collaborationspaceid"
            ]
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        },
        "emailtemplateid": {
            "type": "string"
        },
        "emailtemplateparams": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "teamid": {
            "type": "string"
        }
    },
    "actions": {
        "shareLibraryToTeams": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "selectedTeams": "{{data.selectedTeams}}",
                            "libraryId": "{{props.libraryid}}"
                        },
                        "query": "mutation AddTeamsToLibrary( $addTeamsToLibraryInput: Json) {addTeamsToLibrary( addTeamsToLibraryInput: $addTeamsToLibraryInput) }",
                        "variables": {
                            "addTeamsToLibraryInput": {
                                "libraryId": "{{props.libraryid}}",
                                "emailTemplateId": "{{props.emailtemplateid}}",
                                "emailTemplateParams": "{{props.emailtemplateparams}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "sharedTeam": "data.data.addTeamsToLibrary",
                "error": "data.data.addTeamsToLibrary"
            },
            "events": {
                "success": [
                    {
                        "name": "shareLibraryToTeamsSuccess",
                        "eventData": {
                            "eventName": "shareLibraryToTeamsSuccess",
                            "eventData": "{{sharedTeam}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "displayShareLibrarySuccessMsg"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "subscribeTeamsEventAction": {
            "actionType": "JSFunction",
            "method": "storeTeamsData",
            "inputData": {
                "data": "{{data}}",
                "selectedTeams": "{{parameters.eventData}}"
            },
            "deps": "js/desUpdateLibraryService"
        },
        "setCustomAttribute": {
            "actionType": "JSFunction",
            "method": "setCustomAttribute",
            "deps": "js/desUpdateLibraryService"
        }
    },
    "messages": {
        "displayShareLibrarySuccessMsg": {
            "messageType": "INFO",
            "messageText": "{{i18n.shareLibrarySuccessMsg}}"
        }
    },
    "onEvent": [
        {
            "eventId": "shareLibraryToTeamsSuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "shareLibraryToTeamsSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "selectedTeamsSuccess",
            "action": "subscribeTeamsEventAction",
            "inputArgs": {
                "eventName": "selectedTeamsSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "i18n": {
        "users": [
            "DesLibraryMessages"
        ],
        "teams": [
            "DesLibraryMessages"
        ],
        "shareButton": [
            "libraryMessages"
        ],
        "searchUsersString": [
            "DesLibraryMessages"
        ],
        "searchTeamsString": [
            "DesLibraryMessages"
        ],
        "shareLibrarySuccessMsg": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesShareLibraryToTeams",
    "_uniqueViewModelId": "DesShareLibraryToTeams",
    "ctx": {}
};

    /*
    <aw-panel>
    <des-share-library-search-box accsessionid={{props.accsessionid}}></des-share-library-search-box>
    <des-share-library-search-results-for-teams accsessionid={{props.accsessionid}} libraryid={{props.libraryid}}
        collaborationspaceid="{{props.collaborationspaceid}}"></des-share-library-search-results-for-teams>
    <aw-panel-footer>
        <aw-button class='small' button-type='accent-high-contrast' size='stretched'
            action='shareLibraryToTeams'>{{i18n.shareButton}}</aw-button>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <DesShareLibrarySearchBox accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        </DesShareLibrarySearchBox>
        <DesShareLibrarySearchResultsForTeams accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} libraryid={AwParseService.instance( "props.libraryid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} collaborationspaceid={AwParseService.instance( "props.collaborationspaceid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        </DesShareLibrarySearchResultsForTeams>
        <AwPanelFooter>
            <AwButton className="small" buttonType="accent-high-contrast" size="stretched" action={actions.shareLibraryToTeams}>
                {AwParseService.instance( "i18n.shareButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButton>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;